module.exports = __webpack_public_path__ + "static/media/replay.0118ef60.png";